<template>
	<div class="editor">
		<h1>Job Names Mapping Config Editor</h1>
		<div class="container-fluid">
			<div class="col-md-4">
				<h3><i class="fa fa-arrow-circle-left pull-right" aria-hidden="true"></i>Schoox Job Name</h3>
			</div>

			<div class="col-md-4">
				<h3><i class="fa fa-arrow-circle-left pull-right" aria-hidden="true"></i>Hot Schedules Job Names</h3>
			</div>

			<div class="col-md-4">
				<h3>Available Jobs</h3>
			</div>
		</div>
		<div class="container-fluid">

			<div class="col-md-4">
				<input type="text" class="form-control" v-validate.initial="name" data-vv-rules="required|uniqueJobName" v-model="name" name="toName">

				<br>
				<div class="text-center">
					<button v-on:click="cancel"><i class="fa fa-window-close" aria-hidden="true"></i> Cancel</button>
					<button v-on:click="finish"><i class="fa fa-save" aria-hidden="true"></i> Finish and Save</button>
				</div>
				<br>
				<ul class="text-danger">
					<li class="text-danger" v-if="errors.has('toName')">{{ errors.first('toName') }}</li>
					<li class="text-danger" v-if="errors.has('hsNames')">{{ errors.first('hsNames') }}</li>
					<li class="text-danger" v-if="available.length === 0">There are no available job names. You will need to either remove some from another job name config or add the approriate job name in Hot Schedules.</li>
				</ul>

			</div>

			<div class="col-md-4">
				<div class="hs-names">
					<draggable class="draglist" :list="hsNames" :options="hsOptions"  @add="updateHsNameCount" @remove="updateHsNameCount">
						   <div v-for="name in hsNames" class="hs-name">{{name}}</div>
					</draggable>

				</div>

				<input type="hidden" name="hsNames" v-model="hsNameCount" v-validate.initial="hsNameCount" data-vv-rules="notEmptyList|required">
					<!-- <p class="text-danger" v-if="errors.has('hsNames')">{{ errors.first('hsNames') }}</p> -->
			</div>

			<div class="col-md-4">
				<div class="available-names">
					<draggable class="draglist" :list="available" :options="availableOptions" @start="dragging=true">
					   <div v-for="name in available" class="available-job">{{name}}</div>
					</draggable>
				</div>


			</div>
		</div>
		<div class="container-fluid">

			<div class="col-md-4"></div>

			<div class="col-md-8">
				<div class="group">
					<p class="editor-instructions text-center">Add/Remove Job Names by dragging them.<br> Note: any jobs used in another configuration row will not appear in the available jobs list.</p>
				</div>
			</div>
		</div>
	</div>

</template>
<script>
import _ from 'underscore'
import draggable from 'vuedraggable'
import { Validator } from 'vee-validate'

const options = {
	available: {
		group: {
			name: 'jobs',
			put: true,
			clone: false
		},
		sort: false
	},
	hs: {
		group: {
			name: 'jobs',
			put: true,
			clone: false
		},
		sort: true
	}
}

const props = {
	'available': {
		type: Array,
		default: []
	},
	'toName': {
		type: String,
		default: ''
	},
	'hsNames': {
		type: Array,
		default: () => []
	},
	'restricted': {
		type: Array,
		default: () => []
	},
	'index': {
		type: Number,
		required: true
	}
}

export default{
	props: props,
	components: { draggable },
	name: 'job-config',
	data () {
		return {
			hsNameCount: 0,
			name: ''
		}
	},
	computed: {
		hsOptions: () => options.hs,
		availableOptions: () => options.available
	},
	methods: {
		cancel () {
			// hack fix for dragged available options disapearing
			window.location.reload()
		},
		finish () {
			this.$validator.validateAll()
			if (!this.errors.any()) {
				this.$emit('finish', this.index, {
					scxJobName: this.name,
					hsNames: this.hsNames
				})
			}
		},
		setAvailableJobs () {
			let usedNames = _.chain(this.rows).map((row) => {
				let names = _.clone(row.hsNames)
				names.push(row.scxJobName)
				return names
			}).flatten().value()

			this.editor.available = _.difference(this.$store.state.jobswap.list, usedNames)
		},
		updateHsNameCount () {
			this.hsNameCount = this.hsNames.length
		}
	},
	created () {
		this.name = this.toName
	},
	beforeMount () {
		Validator.updateDictionary({
			en: {attributes: {toName: 'Schoox Job Name'}}
		})
		Validator.extend('uniqueJobName', {
			getMessage: field => 'The schoox job name must be unique',
			validate: value => {
				return _.indexOf(this.restricted, value) === -1
			}
		})
		Validator.extend('notEmptyList', {
			getMessage: field => 'You must select at least one Hot Schedules Job Name',
			validate: value => {
				return value > 0
			}
		})
	},
	mounted () {
		this.updateHsNameCount()
		this.$emit('ready', this.$el)
	},
	beforeDestroy () {
		// makes sure custom rule is removed
		// will throw error if added twice
		Validator.remove('uniqueJobName')
		Validator.remove('notEmptyList')
	}
}

</script>
<style>
.editor h3{
	margin-top: 0;
}
.available-job, .hs-name{
	border-bottom:  1px solid #333;
	padding: 0.2em 0.6em;
}
.available-names, .hs-names{
	height: 250px;
	border:  1px solid #333;
	overflow: auto;
}
.draglist{
	min-height: 250px;
}
.config-table>tbody>tr>td{

}
.editor .text-danger{
	margin-top: 10px;
}
.config-table th button{
	font-weight: normal;
}
.config-table th:first-child{
	width: 300px;
}
.config-table>tbody>tr>td:nth-child(3), .config-table>thead>tr>th:nth-child(3){
	width: 60px;
	text-align: center;
}
.config-table>tbody>tr>td:nth-child(4), .config-table>thead>tr>th:nth-child(4){
	width: 180px;
	text-align: center;
}
.sortable-ghost{
	background: #fff9c4;
}
.sortable-drag{
	background: #ffffff;
	border:  1px solid #333;
}
.editor-instructions{
	margin-top: 10px;
	font-style: italic;
}

</style>


// WEBPACK FOOTER //
// JobNameMapEditor.vue?08790cf0